export const getSuperAdminEmails = () =>
  (process.env.REACT_APP_SUPERADMINS || '')
    .split(',')
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean);

export const isSuperAdminEmail = (email) =>
  !!email && getSuperAdminEmails().includes(email.toLowerCase());
